import StatementTop from "../../../components/elements/statements/statementTop";
import StatementBottom from "../../../components/elements/statements/statementBottom";
import CInput from "../../../components/elements/customInput";
import CCheckbox from "../../../components/elements/customCheckbox";
import FilePicker from "../../../components/elements/filepicker";
import DatePicker from "../../../components/elements/datepicker";
import { scrollToElement } from "../../../helpers/helpers";
import { mapState } from "ui.vue3.vuex";
import Validator from "../../../helpers/validation";
import { StatementComponentNames } from "../../../helpers/data";
import ClaimStatementStepTwo from "./step-2";

const ClaimStatementStepOne = {
    template: /*html*/ `
  <form class="statement-form" action="#">
    <StatementTop
      active-step="1"
      step-amount="3"
    />
    <div class="statement-middle">
      <div class="statement__step statement__step-1">
        <div class="statement__notification text-large">
          <p>Просим Вас заполнить заявление, подробно изложив в нем суть Вашего обращения. </p>
          <p>В случае начисления штрафных санкций или иных расходов с вашей стороны, вызванных непоступлением/ несвоевременным поступление денежных средств по вашему переводу, просим вас приложить подтверждающие документы.</p>
          <p>На указанный Вами адрес электронной почты будет направлен регистрационный номер Вашего заявления, сообщив который, Вы сможете получить информацию о статусе рассмотрения Вашего заявления.</p>
          <p>При необходимости получения дополнительной информации наши специалисты свяжутся с Вами по указанному Вами контактному телефону или адресу электронной почты.</p>
          <p>Заполните следующие поля для оформления заявления.</p>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Личные данные</p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">

              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.last_name"
                  :name="last_name.name"
                  :title="last_name.title"
                  :type="last_name.type"
                  :required="last_name.required"
                  :validation="last_name.validation"
                  v-model="data.last_name"
                />
              </div>

              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.first_name"
                  :name="first_name.name"
                  :title="first_name.title"
                  :type="first_name.type"
                  :required="first_name.required"
                  :validation="first_name.validation"
                  v-model="data.first_name"
                />
              </div>

              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.middle_name"
                  :name="middle_name.name"
                  :title="middle_name.title"
                  :type="middle_name.type"
                  :required="middle_name.required"
                  :validation="middle_name.validation"
                  v-model="data.middle_name"
                  :disabled="data.is_middle_name_required"
                />
              </div>
              
              <div class="area-form__fields-item flex align-center">
                <CCheckbox
                  :title="no_middle_name.title"
                  :checkbox-id="no_middle_name.id"
                  :check-var="data.is_middle_name_required"
                  @on_change="onNoMiddleNameChange"
                />
              </div>
              <div class="area-form__fields-item">
                <DatePicker 
                  :ref="ref_names.birth_date"
                  :name="birth_date.name"
                  :title="birth_date.title"
                  :type="birth_date.type"
                  :required="birth_date.required"
                  v-model="data.birth_date"
                  :validation="birth_date.validation"
                  :mask="birth_date.mask"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Контактные данные</p>
            <div class="area-form__fields grid col-xxl-2 col-md-1">
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.phone"
                  :name="phone.name"
                  :title="phone.title"
                  :type="phone.type"
                  :required="phone.required"
                  :validation="phone.validation"
                  v-model="data.phone"
                  :mask="phone.mask"
                />
              </div>
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.email"
                  :name="email.name"
                  :title="email.title"
                  :type="email.type"
                  :required="email.required"
                  :validation="email.validation"
                  v-model="data.email"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Паспортные данные</p>
            <div class="area-form__fields grid col-xxl-2 col-xl-1">
              <div class="area-form__fields grid col-xxl-2">
                <div class="area-form__fields-item">
                  <CInput
                    :ref="ref_names.passport_series"
                    :name="passport_series.name"
                    :title="passport_series.title"
                    :type="passport_series.type"
                    :required="passport_series.required"
                    :validation="passport_series.validation"
                    v-model="data.passport_series"
                    :mask="passport_series.mask"
                  />
                </div>
                <div class="area-form__fields-item">
                  <CInput
                    :ref="ref_names.passport_number"
                    :name="passport_number.name"
                    :title="passport_number.title"
                    :type="passport_number.type"
                    :required="passport_number.required"
                    :validation="passport_number.validation"
                    v-model="data.passport_number"
                    :mask="passport_number.mask"
                  />
                </div>
              </div>
              <div class="area-form__fields grid col-xxl-2 col-md-1">
                <div class="area-form__fields-item">
                  <CInput
                    :ref="ref_names.passport_subdivision_code"
                    :name="passport_subdivision_code.name"
                    :title="passport_subdivision_code.title"
                    :type="passport_subdivision_code.type"
                    :required="passport_subdivision_code.required"
                    :validation="passport_subdivision_code.validation"
                    v-model="data.passport_subdivision_code"
                    :mask="passport_subdivision_code.mask"
                  />
                </div>
                <div class="area-form__fields-item">
                  <DatePicker 
                    :ref="ref_names.passport_date"
                    :name="passport_date.name"
                    :title="passport_date.title"
                    :type="passport_date.type"
                    :required="passport_date.required"
                    v-model="data.passport_date"
                    :validation="passport_date.validation"
                    :mask="passport_date.mask"
                  />
                </div>
              </div>
              <div class="area-form__fields-item grid col-xxl-1">
                <CInput
                  :ref="ref_names.passport_subdivision_title"
                  :name="passport_subdivision_title.name"
                  :title="passport_subdivision_title.title"
                  :type="passport_subdivision_title.type"
                  :required="passport_subdivision_title.required"
                  :validation="passport_subdivision_title.validation"
                  v-model="data.passport_subdivision_title"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area">
          <div class="area-form">
            <p class="h5">Адрес регистрации</p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <CInput
                  :ref="ref_names.address"
                  :name="address.name"
                  :title="address.title"
                  :type="address.type"
                  :required="address.required"
                  :validation="address.validation"
                  v-model="data.address"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="area grid col-xxl-2 col-lg-1">
          <div class="area-form">
            <p class="h5">Разворот паспорта с фотографией</p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <FilePicker 
                  :ref="ref_names.passport_photo_file"
                  :show-notification="passport_photo_file.show_notification"
                  :notification="passport_photo_file.notification"
                  :initial-value="[...data.passport_photo_files]"
                  :required="passport_photo_file.required"
                  :multiple="passport_address_file.multiple"
                  @files_picked="onPassportPhotoFilesPicked"
                  @clear_files="onPassportPhotoFilesCleared"
                />
              </div>
            </div>
          </div>
          <div class="area-form">
            <p class="h5">Разворот паспорта с пропиской</p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <FilePicker 
                  :ref="ref_names.passport_address_file"
                  :show-notification="passport_address_file.show_notification"
                  :notification="passport_address_file.notification"
                  :initial-value="[...data.passport_address_files]"
                  :required="passport_address_file.required"
                  :multiple="passport_address_file.multiple"
                  @files_picked="onPassportAddressFilesPicked"
                  @clear_files="onPassportAddressFilesCleared"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <StatementBottom 
      :next-btn="next_btn"
      :back-btn="back_btn"
      @back_clicked="onBackClicked"
      @next_clicked="onNextClicked"
    />
  </form>
  `,

    name: StatementComponentNames.claim.claim_one,

    props: {
        statementAnchor: {
            type: String,
            default: "",
        },

        goToComponent: {
            type: Function,
        },
    },

    computed: {
        ...mapState({
            statement_data: (state) => state.claim.data,
        }),
    },

    data() {
        return {
            next_btn: {
                show: true,
                text: "Продолжить",
                class: "",
            },

            back_btn: {
                show: false,
                text: "Назад",
                class: "",
            },

            last_name: {
                name: "cyrilic",
                title: "Фамилия",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-Я\s\W]+$/i]],
            },

            first_name: {
                name: "cyrilic",
                title: "Имя",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-Я\s\W]+$/i]],
            },

            middle_name: {
                name: "cyrilic",
                title: "Отчество",
                required: true,
                type: "text",
                validation: [["required"], ["matches", /^[А-Я\s\W]+$/i]],
            },

            no_middle_name: {
                title: "Нет отчества",
                id: "no_middle_name",
            },

            birth_date: {
                name: "birth_date",
                title: "Дата рождения",
                required: true,
                type: "text",
                validation: [
                    ["required"],
                    ["date"],
                    ["before", new Date()],
                    ["after", new Date(1900, 0, 1)],
                    ["inAdulthood"],
                ],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            phone: {
                name: "phone",
                title: "Номер телефона",
                required: true,
                type: "text",
                validation: [["required"], ["min", 18]],
                mask: {
                    mask: "+7 (999) 999-99-99",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            email: {
                name: "email_example",
                title: "Адрес электронной почты",
                required: true,
                type: "text",
                validation: [
                    ["required"],
                    ["matches", /^[-\w.]+@([A-z0-9][-A-z0-9]+\.)+[A-z]{2,4}$/],
                    ["min", 6],
                    ["max", 300],
                ],
            },

            passport_series: {
                name: "passport_series",
                title: "Серия",
                required: false,
                type: "text",
                validation: [["optional"], ["min", 4]],
                mask: {
                    mask: "9999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            passport_number: {
                name: "passport_number",
                title: "Номер ",
                required: false,
                type: "text",
                validation: [["optional"], ["min", 6]],
                mask: {
                    mask: "999999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            passport_subdivision_code: {
                name: "passport_subdivision_code",
                title: "Код подразделения",
                required: false,
                type: "text",
                validation: [["optional"], ["min", 7]],
                mask: {
                    mask: "999-999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            passport_date: {
                name: "yesterday",
                title: "Дата выдачи",
                required: false,
                type: "text",
                validation: [["optional"], ["date"], ["before", new Date()], ["after", new Date(1900, 0, 1)]],
                mask: {
                    mask: "99.99.9999",
                    showMaskOnHover: !1,
                    placeholder: "_",
                },
            },

            passport_subdivision_title: {
                name: "passport_subdivision_title",
                title: "Кем выдан",
                required: false,
                type: "text",
                validation: [["optional"], ["matches", /^[А-Я\s\W\d]+$/i]],
            },

            address: {
                name: "address",
                title: "Адрес",
                required: false,
                type: "text",
                validation: [["optional"], ["matches", /^[А-Я\s\W\d]+$/i]],
            },

            passport_photo_file: {
                notification: "Загрузите файл в формате .jpg, .pdf",
                show_notification: true,
                required: false,
                multiple: false,
            },

            passport_address_file: {
                notification: "Загрузите файл в формате .jpg, .pdf",
                show_notification: true,
                required: false,
                multiple: false,
            },

            data: {
                last_name: "",
                first_name: "",
                middle_name: "",
                birth_date: "",
                phone: "",
                email: "",
                passport_series: "",
                passport_number: "",
                passport_subdivision_code: "",
                passport_subdivision_title: "",
                passport_date: "",
                address: "",

                passport_photo_files: [],

                passport_address_files: [],

                is_middle_name_required: false,
            },

            ref_names: {
                last_name: "last_name",
                first_name: "first_name",
                middle_name: "middle_name",
                birth_date: "birth_date",
                phone: "phone",
                email: "email",
                passport_series: "passport_series",
                passport_number: "passport_number",
                passport_subdivision_code: "passport_subdivision_code",
                passport_date: "passport_date",
                passport_subdivision_title: "passport_subdivision_title",
                address: "address",
                passport_photo_file: "passport_photo_file",
                passport_address_file: "passport_address_file",
            },

            ref_order: [],

            refs_with_errors: [],

            form_has_errors: false,
        };
    },

    watch: {
        "data.last_name": function () {
            if (this.data.last_name) {
                this.data.last_name =
                    this.data.last_name[0].toUpperCase() + this.data.last_name.substring(1).toLowerCase();
            }
        },

        "data.first_name": function () {
            if (this.data.first_name) {
                this.data.first_name =
                    this.data.first_name[0].toUpperCase() + this.data.first_name.substring(1).toLowerCase();
            }
        },

        "data.middle_name": function () {
            if (this.data.middle_name) {
                this.data.middle_name =
                    this.data.middle_name[0].toUpperCase() + this.data.middle_name.substring(1).toLowerCase();
            }
        },

        "data.birth_date": function () {
            this.checkPassportDate();
        },

        "data.passport_date": function () {
            this.checkPassportDate();
        },
    },

    created() {
        this.getStoreData();
        this.fillRefOrder();
        this.onNoMiddleNameChange(this.data.is_middle_name_required);
    },

    methods: {
        onBackClicked() {
            return;
        },

        checkPassportDate() {
            const dateArray = this.data.birth_date.split(".");

            if (Validator.isDateValid(dateArray)) {
                const date = new Date(+dateArray[2] + 14, +dateArray[1] - 1, +dateArray[0]);
                this.passport_date.validation = [["optional"], ["date"], ["before", new Date()], ["afterEquals", date]];
            } else {
                this.passport_date.validation = [
                    ["optional"],
                    ["date"],
                    ["before", new Date()],
                    ["afterEquals", new Date(1900, 0, 1)],
                ];
            }
        },

        async onNextClicked() {
            this.setStatementData();

            await this.submitForm();

            if (!this.form_has_errors) {
                this.scrollToTop();
                // this.$router.push({ name: "claim-2" });
                this.goToComponent({ component: ClaimStatementStepTwo });
            }
        },

        fillRefOrder() {
            this.ref_order = [
                this.ref_names.last_name,
                this.ref_names.first_name,
                this.ref_names.birth_date,
                this.ref_names.phone,
                this.ref_names.email,
                this.ref_names.passport_series,
                this.ref_names.passport_number,
                this.ref_names.passport_subdivision_code,
                this.ref_names.passport_date,
                this.ref_names.passport_subdivision_title,
                this.ref_names.address,
                this.ref_names.passport_photo_file,
                this.ref_names.passport_address_file,
            ];

            if (!this.data.is_middle_name_required) {
                const index = this.ref_order.findIndex((item) => item === this.ref_names.first_name);

                this.ref_order.splice(index + 1, 0, this.ref_names.middle_name);
            }
        },

        validateForm() {
            this.refs_with_errors = [];

            this.ref_order.forEach((ref) => {
                const hasError = this.$refs[ref].hasValidationErrors();

                if (hasError) {
                    this.refs_with_errors.push(ref);
                }
            });
        },

        async submitForm() {
            this.form_has_errors = false;
            await this.$nextTick(() => {});

            this.validateForm();

            if (this.refs_with_errors.length) {
                this.form_has_errors = true;
                scrollToElement({
                    el: this.$refs[this.refs_with_errors[0]].$el,
                    time: 200,
                    animation: "swing",
                    offset: 100,
                });
            }
        },

        getStoreData() {
            this.data.last_name = this.statement_data.last_name;
            this.data.first_name = this.statement_data.first_name;
            this.data.middle_name = this.statement_data.middle_name;
            this.data.birth_date = this.statement_data.birth_date;
            this.data.phone = this.statement_data.phone;
            this.data.email = this.statement_data.email;
            this.data.passport_series = this.statement_data.passport_series;
            this.data.passport_number = this.statement_data.passport_number;
            this.data.passport_subdivision_code = this.statement_data.passport_subdivision_code;
            this.data.passport_subdivision_title = this.statement_data.passport_subdivision_title;
            this.data.passport_date = this.statement_data.passport_date;

            this.data.passport_photo_files = this.statement_data.passport_photo_files;

            this.data.passport_address_files = this.statement_data.passport_address_files;

            this.data.address = this.statement_data.address;
            this.data.is_middle_name_required = this.statement_data.is_middle_name_required;
        },

        setStatementData() {
            this.$store.commit("claim/setFirstStepData", { data: this.data });
        },

        scrollToTop() {
            const el = document.querySelector(`#${this.statementAnchor}`);

            if (el) {
                scrollToElement({ el: el, time: 200, animation: "swing" });
            }
        },

        onPassportPhotoFilesPicked(files) {
            this.data.passport_photo_files = files;
        },

        onPassportPhotoFilesCleared() {
            this.data.passport_photo_files = [];
        },

        onPassportAddressFilesPicked(files) {
            this.data.passport_address_files = files;
        },

        onPassportAddressFilesCleared() {
            this.data.passport_address_files = [];
        },

        onNoMiddleNameChange(val, id) {
            this.data.is_middle_name_required = val;

            if (this.data.is_middle_name_required) {
                this.middle_name.validation = [["optional"]];
                this.data.middle_name = null;
                this.middle_name.required = false;
            } else {
                this.middle_name.validation = [["required"], ["matches", /^[А-Я\s\W]+$/i]];
                this.middle_name.required = true;
            }

            this.fillRefOrder();
        },
    },

    components: {
        StatementTop,
        StatementBottom,
        CInput,
        CCheckbox,
        FilePicker,
        DatePicker,
        ClaimStatementStepTwo,
    },
};

export default ClaimStatementStepOne;
